import { atom } from 'jotai';

export const isSidebarCollapsedAtom = atom(true);
